<!--
 * $Description: 业务操作：新增、编辑、查看等操作栏
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年01月06日 09:43:59 +0800
 * @最后修改时间: 2022-03-17 14:26:22
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_CardActions.vue
 -->
<template>
  <v-card-actions
    align="end"
    style="height: 80px"
    class="d-flex flex-wrap justify-center grey lighten-2 max-width"
    :class="animated ? 'animated slideInUp' : ''"
  >
    <v-btn
      rounded
      color="primary"
      class="pl-7 pr-7 text-button"
      style="height: 32px"
      small
      v-show="closeBtn"
      @click="toClose"
      >{{ $t("label_shut_down") }}</v-btn
    >
    <v-btn
      text
      class="pl-7 pr-7 text-button"
      rounded
      color="primary"
      small
      style="height: 32px"
      v-show="cancelBtn"
      @click="toCancel"
      >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
    >
    <v-btn
      text
      class="pl-7 pr-7 text-button"
      rounded
      color="primary"
      small
      style="height: 32px"
      v-show="preStep"
      @click="toPre"
      >{{ $t("label_essweb_form_tools_previousBtnLabel") }}</v-btn
    >

    <v-btn
      rounded
      color="primary"
      class="pl-7 pr-7 text-button"
      style="height: 32px"
      small
      :loading="loading || onLoading"
      v-show="newBtn"
      @click="toNew"
      :disabled="loading || onLoading"
      >{{ $t(newText) }}</v-btn
    >
    <v-btn
      rounded
      color="primary"
      class="pl-7 pr-7 text-button"
      style="height: 32px"
      :disabled="loading || canOkBtn || onLoading"
      small
      :loading="loading || onLoading"
      v-show="saveBtn"
      @click="toSave"
      >{{ $t(saveText) }}</v-btn
    >

    <v-btn
      rounded
      color="primary"
      class="pl-7 pr-7 text-button"
      style="height: 32px"
      small
      v-show="step"
      @click="toNext"
      >{{ $t("label_essweb_form_tools_nextBtnLabel") }}</v-btn
    >
    <v-btn
      rounded
      color="primary"
      class="pl-7 pr-7 text-button"
      small
      :loading="loading || onLoading"
      :disabled="loading || canOkBtn || onLoading"
      style="height: 32px"
      v-show="okBtn"
      @click="toOk"
      >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
    >
    <v-btn
      rounded
      color="primary"
      class="pl-7 pr-7 text-button"
      small
      :disabled="loading || canSubmitBtn || onLoading"
      style="height: 32px"
      v-show="submitBtn"
      :loading="loading || onLoading"
      @click="toSubmit"
      >{{ $t("label_essweb_form_tools_submitBtnLabel") }}</v-btn
    >
  </v-card-actions>
</template>
<script>
export default {
  name: "CardActions",
  props: {
    needValidate: { default: false, type: Boolean }, //是否验证编辑过
    cancelBtn: { default: true, type: Boolean },
    closeBtn: { default: false, type: Boolean },
    animated: { default: true, type: Boolean },
    saveBtn: { default: false, type: Boolean },
    saveText: { default: "label_essweb_form_tools_saveBtnLabel", type: String },
    newText: { default: "label_essweb_form_tools_newBtnLabel", type: String },
    newBtn: { default: false, type: Boolean },
    nextBtn: { default: false, type: Boolean },
    okBtn: { default: false, type: Boolean },
    submitBtn: { default: false, type: Boolean },
    okBtnDisabled: { default: false, type: Boolean },
    submitBtnDisabled: { default: false, type: Boolean },
    step: { default: false, type: Boolean },
    preStep: { default: false, type: Boolean },
    changed: { default: false, type: Boolean }, //被修改过
    onLoading: { default: false, type: Boolean }, //正在加載
    isSubmitDelay: { default: null, type: [Boolean, Number, String] }, // 提交按钮延迟秒数
  },
  computed: {
    canOkBtn: {
      get() {
        return this.okBtnDisabled;
      },
      set(val) {
        return val;
      },
    },
    canSubmitBtn: {
      get() {
        return this.submitBtnDisabled;
      },
      set(val) {
        return val;
      },
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    const that = this;
    //处理图片未加载完成，不能提交的问题
    if (this.isSubmitDelay !== null && !this.canOkBtn) {
      if (!this.canOkBtn) this.canOkBtn = true;
      if (typeof this.isSubmitDelay == "boolean" && this.isSubmitDelay) {
        this.$Sleep(1 * 1000).then(() => {
          if (that.canOkBtn) that.canOkBtn = false;
        });
      } else if (typeof this.isSubmitDelay == "number") {
        this.$Sleep(Number(this.isSubmitDelay) * 1000).then(() => {
          if (that.canOkBtn) that.canOkBtn = false;
        });
      }
    }
    if (this.isSubmitDelay !== null && !this.canSubmitBtn) {
      if (!this.canSubmitBtn) this.canSubmitBtn = true;
      if (typeof this.isSubmitDelay == "boolean" && this.isSubmitDelay) {
        this.$Sleep(1 * 1000).then(() => {
          if (that.canSubmitBtn) that.canSubmitBtn = false;
        });
      } else if (typeof this.isSubmitDelay == "number") {
        this.$Sleep(Number(this.isSubmitDelay) * 1000).then(() => {
          if (that.canSubmitBtn) that.canSubmitBtn = false;
        });
      }
    }
  },
  methods: {
    toNew: function () {
      const that = this;
      if (this.loading) return;
      this.loading = true;
      this.toSetPageTriger(() => that.$emit("new"));
    },
    toSave: function () {
      const that = this;
      if (this.loading) return;
      this.loading = true;
      this.toSetPageTriger(() => that.$emit("save"));
    },
    toNext: function () {
      const that = this;
      if (this.loading) return;
      this.loading = true;
      this.toSetPageTriger(() => that.$emit("next"));
    },
    toOk: function () {
      const that = this;
      if (this.loading) return;
      this.loading = true;
      this.toSetPageTriger(() => that.$emit("ok"));
    },
    toPre: function () {
      const that = this;
      if (this.loading) return;
      this.loading = true;
      this.toSetPageTriger(() => that.$emit("pre"));
    },
    toSubmit: function () {
      const that = this;
      if (this.loading) return;
      this.loading = true;
      this.toSetPageTriger(() => that.$emit("submit"));
    },

    toClose: function () {
      const that = this;
      if (!this.needValidate) {
        that.$emit("close");
      } else {
        if (this.changed) {
          this.$confirmWarn(
            this.$t("message_tips"),
            this.$t("message_essweb_form_textField_refuseChange_title")
          ).then((res) => {
            if (res) {
              that.$emit("close");
            }
          });
        } else {
          that.$emit("close");
        }
      }
    },
    toCancel: function () {
      const that = this;
      if (!this.needValidate) {
        that.$emit("cancel");
      } else {
        if (this.changed) {
          this.$confirmWarn(
            this.$t("message_tips"),
            this.$t("message_essweb_form_textField_refuseChange_title")
          ).then((res) => {
            if (res) {
              that.$emit("cancel");
            }
          });
        } else {
          that.$emit("cancel");
        }
      }
    },
    toSetPageTriger: function (func) {
      const that = this;
      this.$store.dispatch("setPageTriger", true).then(() => {
        func();
      });
      this.$Sleep(1000).then(() => {
        that.$store.dispatch("setPageTriger", false).then(() => {
          that.loading = false;
        });
      });
    },
  },
};
</script>
